import t from"./transitionEmit.js";function i(i=!0,s){const a=this,{params:o}=a;o.cssMode||(o.autoHeight&&a.updateAutoHeight(),t({swiper:a,runCallbacks:i,direction:s,step:"Start"}))}export{i as default};
//# sourceMappingURL=transitionStart.js.map
